module.exports = __webpack_public_path__ + "img/photo-man-couch.6dc01929.jpg";